import { useTranslation } from "react-i18next";

// Custom Functions
import { parseLicensesCsv } from "../lib/parseLicensesCsv";
import { EMPTY_PREVIEW } from "../redux/licenses/state";

//  Redux
import { connect } from "react-redux";
import {
  SetImportFile,
  SetImportPreview,
  SetImportResult,
  SetFormMessage,
} from "../redux/licenses/actions";

// ----------------------------------------------------------------

// Hidden input used by the import modal: reads the selected file and runs
// the client side check before the upload is allowed
function FileUpload(props) {
  const { t } = useTranslation();

  const fncReject = (message) => {
    props.SetImportFile(null);
    props.SetImportPreview(EMPTY_PREVIEW);
    props.SetFormMessage(message);
  };

  const fncFileSelected = (event) => {
    const file = event.target.files[0];
    // Allows selecting the same file twice in a row
    event.target.value = "";

    if (file === undefined || file === null) {
      return;
    }

    props.SetImportResult(null);

    const reader = new FileReader();
    reader.onload = () => {
      const preview = parseLicensesCsv(reader.result);

      if (preview.headerError) {
        fncReject(t("PortalMessages.Error.CsvHeaderInvalid"));
        return;
      }
      if (preview.empty) {
        fncReject(t("PortalMessages.Error.CsvEmpty"));
        return;
      }

      props.SetImportFile(file);
      props.SetImportPreview({
        validCount: preview.validCount,
        unlinkCount: preview.unlinkCount,
        invalidCount: preview.invalidCount,
        sampleErrors: preview.sampleErrors,
      });
      props.SetFormMessage(
        preview.invalidCount > 0
          ? t("PortalMessages.Error.CsvRowsInvalid")
          : null
      );
    };
    reader.onerror = () => {
      fncReject(t("PortalMessages.Error.Server") + " (500).");
    };
    reader.readAsText(file);
  };

  return (
    <input
      type="file"
      accept=".csv,text/csv"
      onChange={fncFileSelected}
      style={{ display: "none" }}
      id="tp_licenses_import"
    />
  );
}

// ----------------------------------------------------------------

// Mapping Hook
const mapDispatchToProps = (dispatch) => {
  return {
    SetImportFile: (value) => dispatch(SetImportFile(value)),
    SetImportPreview: (value) => dispatch(SetImportPreview(value)),
    SetImportResult: (value) => dispatch(SetImportResult(value)),
    SetFormMessage: (value) => dispatch(SetFormMessage(value)),
  };
};
export default connect(null, mapDispatchToProps)(FileUpload);
